/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import OrgAppList from '../views/organization/application/OrgAppList';
import OrgAppCreationBtn from '../views/organization/application/OrgAppCreationBtn';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { getAllOrgsApps } from '../../../../../store/reducers/organization/orgApp/orgAppAction';

const ManageOrgApplicationDetailsPage = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const fetchOrgsApps = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgsApps()).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch])
    useEffect(() => {
        fetchOrgsApps()
    }, [fetchOrgsApps]);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations Applications Details'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppList /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageOrgApplicationDetailsPage; 
